import DataTable from "components/common/data-table/data-table";
import { AWARD_COLUMNS } from "./award-column";
import AwardForm from "./award-form";
import { ASSETS_API, ASSETS_API_PREFIX } from "config-global";
interface AwardProps {}

const Award: React.FC<AwardProps> = () => {
  return (
    <div>
      <DataTable
        tableName="Award"
        parentTableName="Management"
        deleteTitle="Award"
        mainCol="title"
        getAllLink="/api/admin/awards/" //TODO add "api" to base rout
        getItemLink="/api/admin/awards" //TODO add "api" to base rout
        hasEdit={true}
        hasCreate={true}
        hasDelete={true}
        updateItemLink="/api/admin/awards" //TODO add "api" to base rout
        createItemLink="/api/admin/awards" //TODO add "api" to base rout
        deleteRowLink="/api/admin/awards" //TODO add "api" to base rout
        tableCols={AWARD_COLUMNS}
        FormContent={AwardForm}
        formDataMapper={(data: any) => {
          const translationAr = data.translations.find(
            (translation: any) => translation.locale === "ar"
          );
          const translationEn = data.translations.find(
            (translation: any) => translation.locale === "en"
          );
          return {
            ...data,
            title: translationEn?.title,
            titleAr: translationAr?.title,
            description: translationEn?.description,
            descriptionAr: translationAr?.description,
            awardCategory: data.awardCategory?.id,
            coverImage: ASSETS_API + ASSETS_API_PREFIX + data?.coverImageUrl,
          };
        }}
        formSubmitMapper={(data: any) => {
          const formData = new FormData();
          formData.append("translations[0][locale]", "en");
          formData.append("translations[0][title]", data.title);
          formData.append("translations[0][description]", data.description);
          formData.append("translations[1][locale]", "ar");
          formData.append("translations[1][title]", data.titleAr);
          formData.append("translations[1][description]", data.descriptionAr);
          formData.append("published", data.published);

          if (!data?.id || data.coverImage) {
            formData.append("coverImage", data.coverImage);
          }
          if (!data?.id) {
            formData.append("awardCategory", String(data.awardCategory));
          }
          return formData;
        }}
      />
    </div>
  );
};

export default Award;
